var React = require('react');

function PlusVpsIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.1665 9.1665V4.1665H10.8332V9.1665H15.8332V10.8332H10.8332V15.8332H9.1665V10.8332H4.1665V9.1665H9.1665Z","fill":"#E20000"}));
}

PlusVpsIcon.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"#E20000"};

module.exports = PlusVpsIcon;

PlusVpsIcon.default = PlusVpsIcon;
